import { render, staticRenderFns } from "./caseDepartment.vue?vue&type=template&id=ee51dd9a&scoped=true&lang=pug"
import script from "./caseDepartment.vue?vue&type=script&lang=js"
export * from "./caseDepartment.vue?vue&type=script&lang=js"
import style0 from "./caseDepartment.vue?vue&type=style&index=0&id=ee51dd9a&prod&lang=stylus"
import style1 from "./caseDepartment.vue?vue&type=style&index=1&id=ee51dd9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee51dd9a",
  null
  
)

export default component.exports